var FormWrapper = function (_a) {
    var children = _a.children;
    return <div className="flex flex-col gap-4">{children}</div>;
};
export default FormWrapper;
